import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResourceModule } from '@smartsoftware/reflex-core';
import { AestheticsModule } from '../../aesthetics/aesthetics.module';
import { ComponentsModule } from '../../components/components.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatStepperModule } from '@angular/material/stepper';
import { MatInputModule } from '@angular/material/input';
import { AutoLoginPartialRoutesGuard as AuthGuard } from 'angular-auth-oidc-client';
import { CanLeaveService, ClientBranch_Service, Client_Service, LegalReflexLibModule, SuccessCounty_Service, SuccessState_Service, UnsavedChangesGuard } from 'legalreflex-lib';
import { OrderFrame } from './frame/frame';
import { OrderList } from './list/list';
import { OrderView } from './view/view';
import { OrderCreate } from './create/create';
import { OrderSearch } from './search/search';
import { OrderCreatedDialog } from './create/dialog/orderCreated';
import { DirectEFile } from './directEFile/directEFile';
import { OrderPrint_Service } from './orderPrint.service';
import { InvalidDocumentDialog } from './create/dialog/invalidDocument';
import { DocumentNameChangedDialog } from './create/dialog/documentNameChanged';
import { FileSizeDialog } from './create/dialog/fileSize';
import { ErrorReportedDialog } from './create/dialog/errorReportedDialog';
import { ImportDocumentDialog } from './create/dialog/importDocument';
import { LookupFailDialog } from './search/lookupFailDialog';
import { RecursiveFolder } from './create/dialog/recursiveFolder';

const routes: Routes = [
    {
        path: 'order',
        component: OrderFrame,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                component: OrderList
            },
            {
                path: 'new',
                component: OrderCreate,
                canDeactivate: [CanLeaveService]
            },
            {
                path: 'direct-efile',
                component: DirectEFile,
            },
            {
                path: 'clone/:id',
                component: OrderCreate,
                canDeactivate: [CanLeaveService]
            },
            {
                path: 'resume/:id',
                component: OrderCreate,
                canDeactivate: [CanLeaveService]
            },
            {
                path: 'cancel/:id',
                component: OrderView,
            },
            {
                path: 'view',
                component: OrderSearch,
            },
            {
                path: ':id',
                component: OrderView,
                canDeactivate: [UnsavedChangesGuard]
            }
        ]
    }
];

@NgModule({
    declarations: [
        OrderFrame,
        OrderList,
        OrderView,
        OrderCreate,
        OrderSearch,
        OrderCreatedDialog,
        InvalidDocumentDialog,
        DirectEFile,
        DocumentNameChangedDialog,
        ErrorReportedDialog,
        FileSizeDialog,
        ImportDocumentDialog,
        LookupFailDialog,
        RecursiveFolder,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AestheticsModule,
        ComponentsModule,
        ResourceModule,
        BrowserModule,
        BrowserAnimationsModule,
        MatTooltipModule,
        RouterModule,
        LegalReflexLibModule,
        MatFormFieldModule,
        MatInputModule,
        MatStepperModule,

        RouterModule.forChild(routes)
    ],
    providers: [
        ClientBranch_Service,
        Client_Service,
        OrderPrint_Service,
        CanLeaveService,
        SuccessState_Service,
        SuccessCounty_Service
    ],
    exports: [

    ],
    bootstrap: [

    ]
})
export class OrderModule { }
